export default __webpack_public_path__ + "static/media/build-history.d86f3237.svg";